import React from 'react';
import { BuyCreditsModal as SharedBuyCreditsModal, createCreditCheckoutViaSupabase } from '@rehub/buy-credits';
import { supabase } from '../services/supabase';
import type { UserProfile } from '../types';

interface BuyCreditsModalProps {
  user: UserProfile;
  onClose: () => void;
  initialProductId?: string | null;
}

const BuyCreditsModal: React.FC<BuyCreditsModalProps> = ({ user, onClose, initialProductId }) => (
  <SharedBuyCreditsModal
    userId={user.id}
    credits={user.credits ?? 0}
    onClose={onClose}
    appSource="photoclear"
    accent="orange"
    initialProductId={initialProductId ?? undefined}
    createCheckout={(params) => createCreditCheckoutViaSupabase(supabase, params)}
  />
);

export default BuyCreditsModal;
